import Xhr from "../../helpers/Xhr";
import ACTIONS from "../../constants/actions";

export const getInfo = () => dispatch => {
	Xhr.getInfo().then((resp) => dispatch({
		type : ACTIONS.USER.GET_INFO,
		data : resp.data
	}));

	dispatch(getCash());
};

export const getCash = () => dispatch => {
	Xhr.getCash().then((resp) => dispatch({
		type : ACTIONS.USER.GET_CASH,
		data : resp.data
	}));
};

export const logIn = (login, password) => dispatch => {
	dispatch({type : ACTIONS.USER.TOGGLE_FETCHING});

	Xhr.login(login, password).then((resp) => {
		dispatch({
			type : ACTIONS.USER.LOGIN,
			data : resp.data,
		});

		if ( resp.status === 'ok' ) {
			dispatch(getInfo());
		}
	});
};

export const logOut = () => dispatch => {
	dispatch({type : ACTIONS.USER.LOGOUT});
	document.location.reload();
};


// WEBPACK FOOTER //
// ./src/app/redux/actions/user.js